import '@babel/polyfill'
import Vue from 'vue'

import '@/plugins/bootstrap-vue'
import './plugins/axios'

import App from './App.vue'
import '@/assets/custom.scss'
import '@/assets/master.css'
import '@/assets/master_basic.css'
import '@/assets/master2.css'
import '@/assets/master3.css'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
